module.exports = __webpack_public_path__ + "static/media/frontDesk.0a5f44c0.svg";